'use strict';

/* eslint-env browser */

module.exports = el => {
  if (!document.getSelection) {
    return;
  }

  el.focus();

  const value = document.getSelection();

  if (typeof value.setBaseAndExtent === 'function') {
    value.setBaseAndExtent(el, 0, el, 1);
    return;
  }

  const range = document.createRange();

  range.selectNodeContents(el);

  value.removeAllRanges();
  value.addRange(range);
};
